import React from 'react';
import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

interface RichTextContainerProps {
  children: React.ReactNode;
  className?: string;
}

const defaultStyles = css`
  blockquote {
    border-left: 0.4rem solid var(--icon-placeholder);
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    padding-inline-start: 1.6rem;
  }
  ul,
  ol {
    padding-inline-start: 1.5em;
  }
  ol {
    list-style-type: decimal;
  }
  ul {
    list-style-type: disc;
  }
  ul li,
  ol li {
    padding-inline-start: 0.5em;
  }

  code {
    white-space: pre-wrap;
  }

  // safari fix for no dimension when p inside span
  .html-container > p:only-child {
    display: inline;
  }

  // if p element is empty add margin to it, this is because we get serialised output from Prosemirror which saved line breaks as <p></p>
  .html-container > p:empty {
    display: flex;
    //  this margin value is the possible line height of the text, it is calculated by using body-short-01 and body-short-02 font sizes
    margin-top: 1.5em;
  }
`;
function RichTextContainer(props: RichTextContainerProps) {
  return <Box className={cn(defaultStyles, props.className)}>{props.children}</Box>;
}
export default RichTextContainer;
